module.exports = __webpack_public_path__ + "media/28_Long.7475c562.mp3";